<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        :loading="loading"
        :title="`${id ? 'Edição' : 'Cadastro'} de setor`"
        @save="$refs.Form.save()"
        large
        ref="Modal"
    >
        <Form
            :id="id"
            @save="handleExit"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        id: null,
    }),
    methods: {
        open(id) {

            this.id = id

            this.$refs.Modal.show()
        },
        handleExit(setor) {

            this.$emit('save', setor)

            this.$refs.Modal.hide()
        },
    }
}
</script>